/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {

    export class WorkflowWorkspaceModel {

        private service: services.WorkflowService;
        private drawingService: services.WorkflowDrawingService;
        private workflowDrawingInstance: WorkflowDrawingInstance;
        private statusFlowChangedCallback: (workflowBlocks: IWorkflowBlock[]) => void;
        private isReadonly: boolean;
        private modalService: any;
        private showZoomAndPan: boolean;
        private processStatusGroup: models.ProcessStatusGroup;
        private processActionGroup: models.ProcessActionGroup;
        private workflowMode: models.WorkflowMode;

        public alwaysShowGotoArrows: boolean;
        
        public scope: directives.IWorkflowWorkspaceScope;
        public rootScope: ng.IRootScopeService;
        public settings: models.WorkflowDrawingSettings;

        public validationIssues: Array<string>;

        constructor(
            settings: models.WorkflowDrawingSettings,
            workflowMode: models.WorkflowMode,
            statusFlowChangedCallback: (workflowBlocks: IWorkflowBlock[]) => void)
        {
            this.settings = settings;
            this.statusFlowChangedCallback = statusFlowChangedCallback;
            this.showZoomAndPan = false;
            this.validationIssues = [];
            this.workflowMode = workflowMode;
        }

        private toggleAlwaysShotGotoArrows(): void {
            this.service.setAlwaysShowGotoArrowsSetting(this.alwaysShowGotoArrows);
            this.service.addOrRemoveFeedbackArrowLines();
        }

        public drawShapesForToolbox() : void {

            if (this.workflowMode === models.WorkflowMode.Workflow) {
                var statusChange = models.WorkflowBlockManager.createWorkflowBlock(Wars.Domain.Model.Codes.Enums.BlockType.StatusChange, "1", this.workflowDrawingInstance);
                statusChange.drawForToolbar(Snap('#statusChangeWorkflowBlock'));

                var state = models.WorkflowBlockManager.createWorkflowBlock(Wars.Domain.Model.Codes.Enums.BlockType.State, "1", this.workflowDrawingInstance);
                state.drawForToolbar(Snap('#stateWorkflowBlock'));

                var gotoState = models.WorkflowBlockManager.createWorkflowBlock(Wars.Domain.Model.Codes.Enums.BlockType.GotoState, "1", this.workflowDrawingInstance);
                gotoState.drawForToolbar(Snap('#gotoStateWorkflowBlock'));
            }

            if (this.workflowMode === models.WorkflowMode.ProcessAction) {
                var returnFromProcessAction = models.WorkflowBlockManager.createWorkflowBlock(Wars.Domain.Model.Codes.Enums.BlockType.ReturnFromProcessAction, "1", this.workflowDrawingInstance);
                returnFromProcessAction.drawForToolbar(Snap('#returnFromProcessActionWorkflowBlock'));

                var changeState = models.WorkflowBlockManager.createWorkflowBlock(Wars.Domain.Model.Codes.Enums.BlockType.ChangeState, "1", this.workflowDrawingInstance);
                changeState.drawForToolbar(Snap('#changeStateWorkflowBlock'));
            }

            var userAction = models.WorkflowBlockManager.createWorkflowBlock(Wars.Domain.Model.Codes.Enums.BlockType.UserAction, "1", this.workflowDrawingInstance);
            userAction.drawForToolbar(Snap('#userActionWorkflowBlock'));

            var condition = models.WorkflowBlockManager.createWorkflowBlock(Wars.Domain.Model.Codes.Enums.BlockType.Condition, "1", this.workflowDrawingInstance);
            condition.drawForToolbar(Snap('#conditionWorkflowBlock'));

            // Bring back when actually implemented. This is the MEF'ed action that can do whatever the extensible interface allows
            // var systemAction = models.WorkflowBlockManager.createWorkflowBlock(Wars.Domain.Model.Codes.Enums.BlockType.CustomAction, "1", this.workflowDrawingInstance);
            // systemAction.drawShape(Snap('#systemActionWorkflowBlock'));

            var processAction = models.WorkflowBlockManager.createWorkflowBlock(Wars.Domain.Model.Codes.Enums.BlockType.ProcessAction, "1", this.workflowDrawingInstance);
            processAction.drawForToolbar(Snap('#processActionWorkflowBlock'));

            var systemAction = models.WorkflowBlockManager.createWorkflowBlock(Wars.Domain.Model.Codes.Enums.BlockType.SystemAction, "1", this.workflowDrawingInstance);
            systemAction.drawForToolbar(Snap('#systemActionWorkflowBlock'));

            var calculate = models.WorkflowBlockManager.createWorkflowBlock(Wars.Domain.Model.Codes.Enums.BlockType.CalculateAction, "1", this.workflowDrawingInstance);
            calculate.drawForToolbar(Snap('#calculateActionWorkflowBlock'));

            var goto = models.WorkflowBlockManager.createWorkflowBlock(Wars.Domain.Model.Codes.Enums.BlockType.Goto, "1", this.workflowDrawingInstance);
            goto.drawForToolbar(Snap('#gotoWorkflowBlock'));

            var message = models.WorkflowBlockManager.createWorkflowBlock(Wars.Domain.Model.Codes.Enums.BlockType.Message, "1", this.workflowDrawingInstance);
            message.drawForToolbar(Snap('#messageWorkflowBlock'));

            var validate = models.WorkflowBlockManager.createWorkflowBlock(Wars.Domain.Model.Codes.Enums.BlockType.Validate, "1", this.workflowDrawingInstance);
            validate.drawForToolbar(Snap('#validateWorkflowBlock'));

            var generatePdf = models.WorkflowBlockManager.createWorkflowBlock(Wars.Domain.Model.Codes.Enums.BlockType.CreatePdfAction, "1", this.workflowDrawingInstance);
            generatePdf.drawForToolbar(Snap('#createPdfActionWorkflowBlock'));

            var copy = models.WorkflowBlockManager.createWorkflowBlock(Wars.Domain.Model.Codes.Enums.BlockType.Copy, "1", this.workflowDrawingInstance);
            copy.drawForToolbar(Snap('#copyWorkflowBlock'));

            var setData = models.WorkflowBlockManager.createWorkflowBlock(Wars.Domain.Model.Codes.Enums.BlockType.SetData, "1", this.workflowDrawingInstance);
            setData.drawForToolbar(Snap('#setDataWorkflowBlock'));

            var assignClaim = models.WorkflowBlockManager.createWorkflowBlock(Wars.Domain.Model.Codes.Enums.BlockType.AssignClaim, "1", this.workflowDrawingInstance);
            assignClaim.drawForToolbar(Snap('#assignClaimWorkflowBlock'));

            var sendEmail = models.WorkflowBlockManager.createWorkflowBlock(Wars.Domain.Model.Codes.Enums.BlockType.SendEmailAction, "1", this.workflowDrawingInstance);
            sendEmail.drawForToolbar(Snap('#sendEmailActionWorkflowBlock'));

            var bookResource = models.WorkflowBlockManager.createWorkflowBlock(Wars.Domain.Model.Codes.Enums.BlockType.BookResource, "1", this.workflowDrawingInstance);
            bookResource.drawForToolbar(Snap('#bookResourceWorkflowBlock'));

            var removeResource = models.WorkflowBlockManager.createWorkflowBlock(Wars.Domain.Model.Codes.Enums.BlockType.RemoveResource, "1", this.workflowDrawingInstance);
            removeResource.drawForToolbar(Snap('#removeResourceWorkflowBlock'));
        }

        public injectDependencies(
            service: services.WorkflowService,
            drawingService: services.WorkflowDrawingService,
            modalService: any,
            scope: directives.IWorkflowWorkspaceScope,
            rootScope: ng.IRootScopeService)
        {
            this.service = service;
            this.drawingService = drawingService;
            this.modalService = modalService;
            this.scope = scope;
            this.rootScope = rootScope;
        }

        public initialize() {
            var svgId = 'mainWorkflowSvg';

            this.alwaysShowGotoArrows = this.service.getAlwaysShowGotoArrowsSetting();

            this.workflowDrawingInstance = new models.WorkflowDrawingInstance(
                svgId,
                this.service,
                this.drawingService,
                this.settings,
                this.scope,
                this.rootScope,
                this.statusFlowChangedCallback,
                () => this.workflowUpdatedCallback(),
                this.modalService);
        }

        public workflowUpdatedCallback(): void {
            if (!this.processStatusGroup) return;
            //this.service.validateStatusGroup(this.processStatusGroup.processStatusGroupDto.id).then((validationIssues) => this.validationIssues = validationIssues);
        }

        public setNewSelectedStatus(processConfigId: string, processStatusGroup: models.ProcessStatusGroup, isReadonly: boolean) {
            this.processStatusGroup = processStatusGroup;
            this.isReadonly = isReadonly;
            this.workflowUpdatedCallback();
            this.workflowDrawingInstance.initializeData(processConfigId, isReadonly);
        }

        public setNewSelectedProcessAction(processConfigId: string, processActionGroup: models.ProcessActionGroup) {
            this.processActionGroup = processActionGroup;
            var isReadonly = processActionGroup ? processActionGroup.processActionGroupDto.isReadonly : true;
            var processActionId = processActionGroup ? processActionGroup.processActionGroupDto.id : undefined;
            this.workflowDrawingInstance.initializeData(processConfigId, isReadonly, processActionId);
            this.drawProcessAction();
        }

        public getSelectedStatusGroup(): models.ProcessStatusGroup {
            return this.processStatusGroup;
        }

        public drawWorkflow() :void {
            if (!this.processStatusGroup.getInitialBlock()) {
                this.processStatusGroup.workflowBlocks.push(models.WorkflowBlockManager.createInitialWorkflowBlock("1", this.workflowDrawingInstance));
            }
            this.attachDrawingInstanceToWorkflowBlocks();
            this.workflowDrawingInstance.drawModel(this.processStatusGroup.getInitialBlock());

            this.service.addOrRemoveFeedbackArrowLines();
        }

        public drawProcessAction(): void {
            if (this.processActionGroup) {
                this.attachDrawingInstanceToWorkflowBlocks();
                var initialBlock = this.processActionGroup.getInitialBlock();
                this.workflowDrawingInstance.drawModel(initialBlock);

                this.settings.xOrigin = 0;
                this.settings.yOrigin = 0;
                this.changeViewBoxSizeAndOffset();

                this.service.addOrRemoveFeedbackArrowLines();
            }
        }

        public changeViewBoxSizeAndOffset(): void {
            this.drawingService.changeViewBoxSizeAndOffset(this.workflowDrawingInstance.paper, this.settings.xOrigin, this.settings.yOrigin, this.settings.getViewBoxWidth(), this.settings.getViewBoxHeight());
        }

        public onDragOver(event: any) {
            var selectedWorkflowShapeType: number = parseInt(localStorage.getItem("workflowBlockSelected"));
            if (selectedWorkflowShapeType !== 0 && !selectedWorkflowShapeType) return;

            var hoverContext = this.workflowDrawingInstance.events.getWorkflowHoverContext(event);

            this.workflowDrawingInstance.draggingNewShape(selectedWorkflowShapeType, hoverContext);
        }

        public onDrop(event: any) {
            var hoverContext = this.workflowDrawingInstance.events.getWorkflowHoverContext(event);
            var selectedWorkflowShapeType: number = parseInt(localStorage.getItem("workflowBlockSelected"));
            if (hoverContext.workflowBlock && (selectedWorkflowShapeType === 0 || selectedWorkflowShapeType)) {
                this.workflowDrawingInstance.droppedNewShapeOnDropZone(selectedWorkflowShapeType, hoverContext.workflowBlock);
            }
            else if (hoverContext.inBetweenFromWorkflowBlock && hoverContext.inBetweenToWorkflowBlock) {
                this.workflowDrawingInstance.droppedNewShapeOnInBetweenDropZone(selectedWorkflowShapeType, hoverContext.inBetweenFromWorkflowBlock, hoverContext.inBetweenToWorkflowBlock);
            }
        }

        private attachDrawingInstanceToWorkflowBlocks(): void {
            var workflowBlocks = this.getWorkflowBlocks();
            for (var i = 0; i < workflowBlocks.length; i++) {
                workflowBlocks[i].setDrawingInstance(this.workflowDrawingInstance);
            }
        }

        private getWorkflowBlocks(): models.IWorkflowBlock[] {
            if (this.processStatusGroup) {
                return this.processStatusGroup.workflowBlocks;
            }
            if (this.processActionGroup) {
                return this.processActionGroup.workflowBlocks;
            }
            return [];
        }
    }
}